import { Tabs } from 'antd';
import { TabsProps } from 'antd/lib';
import styled from 'styled-components';

export const StyledTab = styled(Tabs)<TabsProps>`
  .ant-tabs-ink-bar {
    height: 1px !important;
    background-color: ${props => props.theme.colors.primary.main.filled};
  }

  .ant-tabs-nav-list {
    margin-bottom: 4px;
  }
  .ant-tabs-nav::before {
    bottom: 4px;
  }
  .ant-tabs-tab {
    min-height: 50px;
    min-width: 105px;
    justify-content: center;
    font-weight: 400;
    color: ${props => props.theme.colors.secondary.main.text};
  }
  .ant-tabs-tab.ant-tabs-tab-active {
    background-color: ${props => props.theme.colors.primary.light.filled};
    border-radius: 0.375rem 0.375rem 0 0;
  }
  .ant-tabs-tab:hover {
    color: ${props => props.theme.colors.secondary.main.text};
    background-color: ${props => props.theme.colors.primary.light.linearHover};
    border-radius: 0.375rem 0.375rem 0 0;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }
  .ant-tabs-tab-active::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    z-index: 10000;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${props => props.theme.colors.primary.main.filled}; /* triangle color */
  }
  .ant-tabs-tab .ant-tabs-tab-btn .tab-label {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }

  .ant-tabs-tab.ant-tabs-tab-active .tab-label .tab-label-count {
    background-color: transparent;
    color: ${props => props.theme.colors.primary.light.text};
    border: 1px solid ${props => props.theme.colors.primary.light.text};
  }

  .ant-tabs-tab.ant-tabs-tab-active:hover .tab-label .tab-label-count {
    border: 1px solid ${props => props.theme.colors.primary.light.text};
  }

  .ant-tabs-tab:hover .tab-label .tab-label-count {
    background-color: ${props => props.theme.colors.secondary.light.surfaceBg};
    border: 1px solid ${props => props.theme.colors.neutral.light.contentBg};
  }

  &.capsule-tab {
    .ant-tabs-nav::before {
      display: none;
      bottom: 0px;
    }
    .ant-tabs-nav-list {
      margin-bottom: 0px;
      padding: 4px;
    }
    .ant-tabs-tab-active::after {
      content: none;
      display: none;
    }
    .ant-tabs-ink-bar {
      display: none;
    }
    .ant-tabs-tab,
    .ant-tabs-nav {
      max-height: 35px;
      min-height: unset;
    }
    .ant-tabs-tab {
      padding: 4px 8px;
      margin-left: 4px;
    }
    .ant-tabs-tab:first-child {
      margin-left: 0;
    }

    .ant-tabs-nav .ant-tabs-nav-list {
      background-color: ${props => props.theme.colors.primary.light.filled};
      border-radius: 0.375rem;
    }
    .ant-tabs-nav .ant-tabs-tab {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
    }
    .ant-tabs-tab.ant-tabs-tab-active {
      background-color: ${props => props.theme.colors.primary.main.filled};
      border-radius: 4px;
    }
    .ant-tabs-tab.ant-tabs-tab-active .tab-label {
      color: ${props => props.theme.colors.primary.main.text};
    }
    .ant-tabs-tab.ant-tabs-tab-active .tab-label .tab-label-count {
      background-color: ${props => props.theme.colors.neutral.dark.surfaceBg};
    }
  }
`;

export const StyledCountTab = styled.div`
  padding: 1px 4px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.secondary.light.surfaceBg};
  border: 1px solid ${props => props.theme.colors.secondary.light.surfaceBg};
  font-size: 8px;
  font-weight: 800;
  border-radius: 0.375rem;
  transition: all 0.3s ease-out-in;
  color: ${props => props.theme.colors.secondary.main.text};
`;
